import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {Box, CircularProgress} from '@mui/material';
import {auth} from './firebase';
import Login from './Login';
import Home from "./Home";

function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUser(user);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
            >
                <CircularProgress/>
            </Box>
        );
    }

    return (
        <Router>
            <Routes>
                <Route
                    path="/login"
                    element={user ? <Navigate to="/"/> : <Login/>}
                />
                <Route
                    path="/"
                    element={user ? <Home/> : <Navigate to="/login"/>}
                />
            </Routes>
        </Router>
    );
}

export default App;
